import React from 'react'
import { NextPage } from 'next'

import { StandardLayout } from 'shared/layout/StandardLayout'
import { explorePageInitialProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import { ExplorePageProps } from 'types/page'
import { ContentfulTopics, ROUTES } from 'parameters'
import AutoRefinancePage from 'experiences/products/AutoRefinancePage'
import { TopicConstraint } from 'services/ContentfulService/constraints'

const AutoRefinance: NextPage<PagePropsWrapper<ExplorePageProps>> = ({ metaTags, pageProps }): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<AutoRefinancePage articles={pageProps.articles} />
	</StandardLayout>
)

AutoRefinance.getInitialProps = explorePageInitialProps(
	ROUTES.AUTO_REFINANCE,
	TopicConstraint(ContentfulTopics.Auto_Refinance)
)

export default AutoRefinance
